const getDiscountPercentage = (sale, current) => {
  const res = (100 * (+current - +sale)) / current;
  return `-${res.toFixed(0)}%`;
};

export default getDiscountPercentage;
